module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-4.dbf30e7a.svg";